import { Injectable } from '@angular/core';
import { List } from 'linqts';

@Injectable()
export class AppRegistryService {

 private _list:List<any> = new List();


 public getValue(key:string)
 {
     let item = this._list.FirstOrDefault(x=>x.key == key);

     if(item!=null)
     {
         return item.value;
     }

     return null;
 }

 public setValue(key:string,value:any)
 {


     let item = this._list.FirstOrDefault(x=>x.key == key);

     if(item!=null)
     {
       item.value = value;;
     }

     this._list.Add({key:key,value:value});
 }

}